import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { http } from "../../helpers/http";
import { getOutletLink, placeholderHandler } from "../../helpers/help";
import { useDispatch, useSelector } from "react-redux";
import { Rating } from "react-simple-star-rating";
import {
  updateFullScreenLoader,
  updateOnboardingState,
} from "../../redux/actions/authActions";
import useCurrentPosition from "../../helpers/customHooks/useCurrentPosition";
import { toast } from "react-toastify";
import { WISHLIST } from "../../eums/messages";
import CardLoader from "../widgets/CardLoader";
import Auth from "../../auth/Auth";
// import { updateWishistCartCount } from "../../redux/actions/generalActions";
import { updateRestaurantList } from "../../redux/actions/restaurantActions";
import moment from "moment";
import { Modal } from "react-bootstrap";
import NearOutlet from "../modals/NearOutlet";
// import OwlCarousel from 'react-owl-carousel';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
// import { List } from 'react-virtualized';


const Nearbyrest = () => {
  const owlevent = {
    items: 4,
    // loop: true,
    margin: 35,
    nav: true,
    dots: false,
    navText: ["<img src='./assets/img/slide_ar_left.svg' />", "<img src='./assets/img/slide_ar_right.svg' />"],

    responsive: {
      0: {
        items: 1,
      },
      576: {
        items: 2,
        margin: 20,
      },
      768: {
        items: 3,
        margin: 15,
      },
      1200: {
        items: 4,
      },
    },
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openLogoutModal, setOpenLogoutModal] = useState({
    data: '',
    state: false
  });
  const { latitudeData, longitudeData, timezone } = useCurrentPosition();

  let restaurantList = useSelector((state) => state.restaurant.list);

  console.log('sghahgsahsgahsa',restaurantList);

  // const showRecords = restaurantList?.listRestaurants?.slice(0, 8);
  const [isLoading, setLoading] = useState(null);
  const [checked, setChecked] = useState(false)
  const { getLatLong } = useOutletContext();
  const [newLoc, setNewLoc] = useState()
  const { pathname } = useLocation();
  const searchKey = useSelector((state) => state.restaurant.searchKey);


  const url = !pathname.includes("/")

  const restaurant = () => {
    dispatch(updateFullScreenLoader(true));

    if (!newLoc || (!latitudeData && !longitudeData)) {
      return
    }
    let apiParams = new URLSearchParams();
    // apiParams.append("page", 1);
    // apiParams.append("size", 8);
    apiParams = `?${apiParams.toString()}`;
    http(
      {
        method: "POST",
        url: `listRestaurant`,
        isSecure: true,
        body: {
          latitude: newLoc.updatelatitudeData ? newLoc.updatelatitudeData : latitudeData,
          longitude: newLoc.updatelongitudeData ? newLoc.updatelongitudeData : longitudeData,
          timezone: timezone,
          type: "Take Out"
        },
      },
      (res) => {
        if (res.error === "false") {
          dispatch(updateRestaurantList(res));
          dispatch(updateFullScreenLoader(false));
        }
        if (res.error === "true") {
          dispatch(updateFullScreenLoader(false));
        }
 
      }
    );
  };
  useEffect(() => {
    if (newLoc || latitudeData || longitudeData || sessionStorage.getItem("_current_location")) {
      restaurantList.listRestaurants = {}
      restaurant()
      //window.location.reload()
      //dispatch(updateFullScreenLoader(true));
    }

  }, [newLoc, longitudeData, latitudeData, sessionStorage.getItem("_current_location")]);


  useEffect(() => {
    if (getLatLong) {
      setNewLoc(JSON.parse(sessionStorage.getItem('newLocation')));
    }
  }, [getLatLong])

  useEffect(() => {
    restaurantList.listRestaurants = {}

    console.log('listRestaurantsaaaaa',restaurantList?.listRestaurants);
  }, [])



  // const handleFavourite = (data, index) => {
  //   if (!Auth.isUserAuthenticated()) {
  //     dispatch(updateOnboardingState("login"));
  //     return;
  //   }
  //   const newStatus = data.is_like ? 0 : 1;
  //   setLoading(data.outlet[0].outletId);
  //   http(
  //     {
  //       method: "POST",
  //       url: `addOutletToUserFavourite`,
  //       isSecure: true,
  //       body: {
  //         outletId: data.outlet[0].outletId,
  //         status: newStatus,
  //       },
  //     },
  //     (res) => {
  //       if (res.error === "false") {
  //         toast.success(data.is_like ? WISHLIST.DISLIKE : WISHLIST.LIKE);
  //         restaurantList.listRestaurants[index].is_like = newStatus;
  //         dispatch(updateRestaurantList({ ...restaurantList }));
  //         dispatch(updateWishistCartCount());
  //         setLoading(false);
  //       }
  //     }
  //   );
  // };


  useEffect(() => {
    if (!searchKey) {
      restaurant()
    }
  }, [searchKey])
  return (
    <>
      <section className="restaurants_near">
        <div className="cus_container">
          <h4 className="head4 mb-4">Restaurants Near By</h4>
          <div className="restaurants_container restaurants_home">
            <div className="restaurants_group ">
              {/* {restaurantList?.listRestaurants.length < 0 && (
                <p className="nodata_found">No data found</p>
              )} */}
              {
                (restaurantList?.listRestaurants?.length === undefined || restaurantList?.listRestaurants?.length === 0) &&
                <p className="nodata_found">No restaurants available for this location</p>

              }
              {restaurantList?.listRestaurants && restaurantList?.listRestaurants?.length > 0 &&
                <OwlCarousel
                  className="owl-theme "
                  {...owlevent}
                >
                  {/* {!restaurantList?.listRestaurants && (
                    <p className="nodata_found">No data found</p>
                  )} */}




                  {
                    restaurantList?.listRestaurants?.length>0 && restaurantList?.listRestaurants?.map((item) => {
                      return (
                        <div
                          key={item.restaurantId}
                          className="res-box restaurants_item pointer"
                          onClick={() => {
                            if (item.outlet.length > 1) {
                              setOpenLogoutModal({
                                state: true,
                                data: item
                              })
                            } else {
                              navigate(`/restaurant-details/${item.outlet[0].outletId}/menu`)
                            }
                          }}
                        >
                          {isLoading === item.outlet[0].outletId && <CardLoader />}
                          < div className="">
                            <div className="res_img position-relative">



                              <img
                                onError={placeholderHandler}
                                src={item.restaurantImage}
                                alt="restaurant"
                                className="restaurant-img"
                              />
                              {item?.emergency_close === 0 ? (
                                <div className="btn_res open">Open</div>
                              ) : (
                                <div className="btn_res close">Close</div>
                              )}
                            </div>
                            <div className="res_content">
                              <div className="my-2 d-flex align-items-center justify-content-between">
                                <h6 className="head6 text-break">{item.restaurantName}</h6>
                              </div>
                              <div className="ratting_sec d-flex align-items-center">

                                <img
                                  src="./assets/img/star.svg"
                                />
                                <div className="review_start ms-2">
                                  <span>{item.averageReview}</span>
                                </div>
                              </div>

                            </div>

                          </div>
                          {/* <Link > */}
                          {/* <div
                            onClick={() =>
                              setOpenLogoutModal({
                                state: true,
                                data: item
                              })
                            }
                            className="my-2 redC"
                          >



                            {item.outlet.length} outlets near you


                          </div> */}
                          {
                            item.outlet?.length > 1 ? (
                              <div
                                className="my-2 redC"
                              >
                                {item.outlet.length} outlets near you

                              </div>
                            ) : (
                              <div
                                className="my-2 redC visHid"
                              >
                                {item.outlet.length} outlets near you

                              </div>
                            )
                          }

                          {/* </Link> */}
                          <div className="d-flex align-items-center fz14 mt-2">
                            <div className="mintB me-2">{item.outlet[0].displayTime}
                            </div>
                            <span className="timeshow">
                              {moment(item.outlet[0].business_hours.from_time, "h:mm a").format("h:mm A")} -{" "}
                              {moment(item.outlet[0].business_hours.to_time, "h:mm a").format("h:mm A")}

                            </span> <span
                              className="ratingView d-flex align-items-center">
                            </span>
                          </div>
                        </div>
                      )
                    })
                  }


                </OwlCarousel>
              }
            </div>

          </div>
          <h4 className="head4 mb-4 mt-4">Lunch Break</h4>
          <div className="restaurants_container restaurants_home">
            <div className="restaurants_group ">
              {
                (restaurantList?.listRestaurants?.length === undefined || restaurantList?.listRestaurants?.length === 0) &&
                <p className="nodata_found">No restaurants available for this location</p>

              }
              {restaurantList?.listRestaurants?.length > 0 &&
                <OwlCarousel
                  className="owl-theme "
                  {...owlevent}
                >

                  {
                    restaurantList?.listRestaurants?.map((item) => {
                      return (
                        <div
                          key={item.restaurantId}
                          className="res-box restaurants_item pointer"
                          onClick={() => {
                            if (item.outlet.length > 1) {
                              setOpenLogoutModal({
                                state: true,
                                data: item
                              })
                            } else {
                              navigate(`/restaurant-details/${item.outlet[0].outletId}/menu`)
                            }
                          }}
                        >
                          {isLoading === item.outlet[0].outletId && <CardLoader />}
                          < div className="">
                            <div className="res_img position-relative">



                              <img
                                onError={placeholderHandler}
                                src={item.restaurantImage}
                                alt="restaurant"
                                className="restaurant-img"
                              />
                              {item?.emergency_close === 0 ? (
                                <div className="btn_res open">Open</div>
                              ) : (
                                <div className="btn_res close">Close</div>
                              )}
                            </div>
                            <div className="res_content">
                              <div className="my-2 d-flex align-items-center justify-content-between">
                                <h6 className="head6 text-break">{item.restaurantName}</h6>
                              </div>
                              <div className="ratting_sec d-flex align-items-center">

                                <img
                                  src="./assets/img/star.svg"
                                />
                                <div className="review_start ms-2">
                                  <span>{item.averageReview}</span>
                                </div>
                              </div>

                            </div>

                          </div>
                          {/* <Link > */}
                          {/* <div
                            onClick={() =>
                              setOpenLogoutModal({
                                state: true,
                                data: item
                              })
                            }
                            className="my-2 redC"
                          >{item.outlet.length} outlets near you</div> */}
                          {
                            item.outlet?.length > 1 ? (
                              <div
                                className="my-2 redC"
                              >
                                {item.outlet.length} outlets near you

                              </div>
                            ) : (
                              <div
                                className="my-2 redC visHid"
                              >
                                {item.outlet.length} outlets near you

                              </div>
                            )
                          }
                          {/* </Link> */}

                          <div className="d-flex align-items-center fz14 mt-2">
                            <div className="mintB me-2">{item.outlet[0].displayTime}
                            </div>
                            <span className="timeshow">
                              {/* {item.outlet[0].business_hours.from_time}-{item.outlet[0].business_hours.to_time} */}
                              {moment(item.outlet[0].business_hours.from_time, "h:mm a").format("h:mm A")} -{" "}
                              {moment(item.outlet[0].business_hours.to_time, "h:mm a").format("h:mm A")}
                            </span> <span
                              className="ratingView d-flex align-items-center">
                            </span>
                          </div>
                        </div>
                      )
                    })
                  }


                </OwlCarousel>
              }
            </div>

          </div>
          <h4 className="head4 mb-4 mt-4">Dinner</h4>
          <div className="restaurants_container restaurants_home">
            <div className="restaurants_group ">
              {
                (restaurantList?.listRestaurants?.length === undefined || restaurantList?.listRestaurants?.length === 0) &&
                <p className="nodata_found">No restaurants available for this location</p>

              }
              {restaurantList?.listRestaurants?.length > 0 &&
                <OwlCarousel
                  className="owl-theme "
                  {...owlevent}
                >

                  {
                    restaurantList?.listRestaurants?.map((item) => {
                      return (
                        <div
                          key={item.restaurantId}
                          className="res-box restaurants_item pointer"
                          onClick={() => {
                            if (item.outlet.length > 1) {
                              setOpenLogoutModal({
                                state: true,
                                data: item
                              })
                            } else {
                              navigate(`/restaurant-details/${item.outlet[0].outletId}/menu`)
                            }
                          }}
                        >
                          {isLoading === item.outlet[0].outletId && <CardLoader />}
                          < div className="">
                            <div className="res_img position-relative">



                              <img
                                onError={placeholderHandler}
                                src={item.restaurantImage}
                                alt="restaurant"
                                className="restaurant-img"
                              />
                              {item?.emergency_close === 0 ? (
                                <div className="btn_res open">Open</div>
                              ) : (
                                <div className="btn_res close">Close</div>
                              )}
                            </div>
                            <div className="res_content">
                              <div className="my-2 d-flex align-items-center justify-content-between">
                                <h6 className="head6 text-break">{item.restaurantName}</h6>
                              </div>
                              <div className="ratting_sec d-flex align-items-center">

                                <img
                                  src="./assets/img/star.svg"
                                />
                                <div className="review_start ms-2">
                                  <span>{item.averageReview}</span>
                                </div>
                              </div>

                            </div>

                          </div>
                          {/* <Link > */}
                          {/* <div
                            onClick={() =>
                              setOpenLogoutModal({
                                state: true,
                                data: item
                              })
                            }
                            className="my-2 redC"
                          >{item.outlet.length} outlets near you</div> */}
                          {
                            item.outlet?.length > 1 ? (
                              <div
                                className="my-2 redC"
                              >
                                {item.outlet.length} outlets near you

                              </div>
                            ) : (
                              <div
                                className="my-2 redC visHid"
                              >
                                {item.outlet.length} outlets near you

                              </div>
                            )
                          }
                          {/* </Link> */}

                          <div className="d-flex align-items-center fz14 mt-2">
                            {/* <div className="mintB me-2">10
                              mins</div> */}
                            <div className="mintB me-2">{item.outlet[0].displayTime}
                            </div>
                            <span className="timeshow">
                              {moment(item.outlet[0].business_hours.from_time, "h:mm a").format("h:mm A")} -{" "}
                              {moment(item.outlet[0].business_hours.to_time, "h:mm a").format("h:mm A")}

                            </span>

                            <span
                              className="ratingView d-flex align-items-center">
                            </span>
                          </div>
                        </div>
                      )
                    })
                  }


                </OwlCarousel>
              }
            </div>

          </div>

          {restaurantList.listRestaurants &&
            restaurantList.listRestaurants?.length > 0 && (
              <div className="text-center middle-line-RL mt-md-5 mt-4">
                <Link
                  to="/restaurants"
                  className="cusbtn btnsize17 d-block m-auto bttranp"
                >
                  View More
                </Link>
              </div>
            )}
        </div>
      </section>
      {/* <Modal
        show={openLogoutModal}
        onHide={() => setOpenLogoutModal(false)}
        centered
        className="logoutmodal center-close-icon"
      >
        <Modal.Header closeButton></Modal.Header>


        <div className="Cboady-modal">
          <div className="restaurant_modal">
            <div className="restaurant_item">
              <div className="restaurant_img">
                <img src="./assets/img/Restaurantsimg.png" alt=" Restaurant img" className="w-100" />
              </div>
              <div className="restaurant_content px-3">
                <div className="title mb-1">
                  <a>
                    Roosters Salad Bar
                  </a>
                </div>

                <div className="footer_content">
                  <div className="d-block">
                    <div className="ratingView mb-2">
                      <img src="./assets/img/ratingStart.svg" alt="rating view" className="me-1" />
                      4.5
                    </div>
                    <div className="d-flex align-items-center">
                      <div className="mintB me-3">10
                        mins</div>
                      <span className="timeshow">12:00 AM - 11:59 PM</span> <span
                        className="ratingView d-flex align-items-center">

                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="centerBr"></div>
            <div className="head4 mb-2"><span>2 Outlets </span> Near You</div>
            {
              restaurantList.listRestaurants && restaurantList.listRestaurants.map((outlets) => {
                return outlets.outlet((item) => {
                  return (

                    <div className="white_modalBox p-3">
                      <div className="restaurant_item justify-content-between">

                        <div className="restaurant_content">
                          <div className="title mb-1">
                            <a routerLink="/restaurant-detail">
                              {item?.outletName}
                            </a>
                          </div>

                          <div className="footer_content">
                            <div className="d-block">

                              <div className="d-flex align-items-center">
                                <div className="mintB me-3">10
                                  mins</div>
                                <span className="timeshow">12:00 AM - 11:59 PM</span> <span
                                  className="ratingView d-flex align-items-center">

                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="restaurant_col-r">
                          <img src="./assets/img/deliveryModal.png" alt="deliveryModal" className="deliveryModal-img" />
                        </div>
                      </div>
                    </div>
                  )
                })
              })
            }

            <div className="white_modalBox p-3 mt-3">
              <div className="restaurant_item justify-content-between">

                <div className="restaurant_content">
                  <div className="title mb-1">
                    <a routerLink="/restaurant-detail">
                      Roosters Salad Bar
                    </a>
                  </div>

                  <div className="footer_content">
                    <div className="d-block">

                      <div className="d-flex align-items-center">
                        <div className="mintB me-3">10
                          mins</div>
                        <span className="timeshow">12:00 AM - 11:59 PM</span> <span
                          className="ratingView d-flex align-items-center">

                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="restaurant_col-r">
                  <div className="ratingView mb-2">
                    <img src="./assets/img/ratingStart.svg" alt="rating view" className="me-1" />
                    4.5
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </Modal> */}
      <NearOutlet
        openLogoutModal={openLogoutModal?.state}
        data={openLogoutModal?.data}
        setOpenLogoutModal={setOpenLogoutModal}
      />


    </>
  );
};
export default Nearbyrest;
